import React from "react";
import Grid from '@mui/material/Grid2';
import LocalStorageService from '../../services/localStorage';

import {
    Box,
} from '@mui/material';
import './Footer.css'

const localStorageService = LocalStorageService.getService();

const Footer = () => {

    const footerRef = React.useRef();

    const brandingInfo = localStorageService.getBrandingInfo();
    
    React.useEffect(() => {

        if (brandingInfo && footerRef) {
            footerRef.current.innerHTML = JSON.parse(brandingInfo).footer;
        }

    }, [brandingInfo, footerRef]);

    return (
        <Box component="section" className="footerBox">
            <Grid container className="container" style={{padding:'16px'}}>
                <Grid item size={12} >
                    <p style={{padding: '0 9%', textAlign: 'center', marginBottom: '5px'}}>CPT codes, descriptions and data copyright ©2024 American Medical Association. All rights reserved. Applicable FARS/DFARS apply. <br />CDT codes, descriptions and data copyright ©2024 American Dental Association. All rights reserved. </p>
                    <p ref={footerRef} style={{textAlign: 'center'}}></p>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer;